import ProductTagServiceV2 from '../../../services/v2/ProductTagServiceV2';
import productTagUseCaseV2 from './productTagUseCaseV2';

const productTagFactoryV2 = productTagUseCaseV2({
  ProductTagServiceV2: ProductTagServiceV2(),
});

export default productTagFactoryV2;
